module.exports = __webpack_public_path__ + "img/typeText2.f31ea4da.png";